import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;

export default class StatusEntregaForm extends Component {
  state = {
    registro: {
      se_idf: '',
      se_descricao: '',
      se_abrev: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.refs.se_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.se_descricao) || (this.state.registro.se_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.se_abrev) || (this.state.registro.se_abrev === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Abreviatura' });
      return;
    }
    if ((this.state.registro.se_descricao.toUpperCase() === 'PED') || (this.state.registro.se_descricao.toUpperCase() === 'ENT')) {
      Modal.warning({ title: 'Aviso!', content: 'Status não permitido' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { se_idf, se_descricao, se_abrev } = this.state.registro;

    return (
      <Modal
        title={se_idf ? "Edição de Status da Entrega" : "Cadastro de Status da Entrega"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={18} style={{ paddingRight: 10 }}>
              <span>Descrição</span>
              <InputForm
                id="se_descricao"
                ref="se_descricao"
                maxLength={15}
                onChange={this.onChange}
                value={se_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
            <Col xs={24} sm={6}>
              <span>Abreviatura</span>
              <InputForm
                id="se_abrev"
                ref="se_abrev"
                maxLength={3}
                onChange={this.onChange}
                value={se_abrev}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusEntregaForm.js